export default "__VITE_ASSET__84ad3886__"